export const watcherstyles = {
  container: `
  `,
  buttonActions: `
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
  `
}